<template>
  <w-modal :value="value" width="1536" content-padding="px-6" @close="close" @scroll="onScroll">
    <template #header>
      <h1 class="font-medium text-xl">
        選擇訂購店家
      </h1>
    </template>
    <template #content>
      <div class="store-selector">
        <b-loading :active="loading"></b-loading>
        <div class="columns store-selector__content">
          <div class="column">
            <div class="p-0" v-if="menus.length">
              <b-table
                :data="menus"
                :mobile-cards="false"
                :row-class="() => 'store-list__row'"
                :selected.sync="selected"
                class="store-list"
                scrollable
              >
                <b-table-column :th-attrs="columnThAttrs" field="id" label="No." v-slot="props">
                  {{ props.index + 1 }}.
                </b-table-column>
                <b-table-column
                  :th-attrs="columnThAttrs"
                  field="storeInfo.store_detail.name"
                  label="店家名稱"
                  cell-class="store-list__name-column"
                  sortable
                  v-slot="props">
                  <span class="store-list__name-column--icon">
                    選
                  </span>
                  <span class="store-list__name-column--content">
                    {{ props.row.storeInfo.store_detail.name }}
                  </span>
                </b-table-column>
                <b-table-column
                  :th-attrs="columnThAttrs"
                  field="name"
                  label="菜單名稱"
                  sortable
                  v-slot="props"
                >
                  {{ props.row.name }}
                </b-table-column>
                <b-table-column
                  :th-attrs="columnThAttrs"
                  field="menuItems"
                  label="內容(菜單前三項品項)"
                  v-slot="props"
                >
                  {{ getMenuItems(props.row) }}
                </b-table-column>
                <b-table-column
                  :th-attrs="columnThAttrs"
                  field="tags"
                  label="標籤"
                  v-slot="props"
                >
                  <b-tag
                    v-for="(tag, index) in props.row.storeInfo.store_tags"
                    class="mx-1"
                    type="is-light"
                    :key="`store-${props.row.id}-tag-${index}`"
                    rounded>
                    {{ tag.name }}
                  </b-tag>
                </b-table-column>
                <b-table-column
                  :th-attrs="columnThAttrs"
                  field="holiday"
                  label="公休日"
                  v-slot="props"
                >
                  {{ transformClosedDays(props.row.storeInfo.store_close_days) }}
                </b-table-column>
                <b-table-column
                  :th-attrs="columnThAttrs"
                  field="updated_at"
                  label="最後更新日期"
                  sortable
                  v-slot="props"
                >
                  {{ humanizeDate(props.row.updated_at) }}
                </b-table-column>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex items-center justify-end">
        <w-button
          :disabled="loading"
          class="mr-6"
          type="link"
          @click="close"
        >
          取消
        </w-button>
        <w-button
          :disabled="loading || !selected"
          :loading="loading"
          @click="onConfirm"
        >
          確定
        </w-button>
      </div>
    </template>
  </w-modal>
</template>

<script>
import StoreSelectorModal from './StoreSelectorModal';

export default StoreSelectorModal;
</script>

<style lang="scss" scoped>
@import "StoreSelectorModal";
</style>
